<template>
  <div></div>
</template>

<script>
export default {
  name: "SolicitationsDetail"
};
</script>

<style scoped></style>
